const AboutPage = () => {
  return (
    <>
      <div className="page-container about-page-container">
        <div className="hero">
          <img
            src="https://d14n4fsapeewqj.cloudfront.net/about/about-hero-image.webp"
            alt=""
          />
          <h1>About BBI</h1>
        </div>
        <div className="sect2">
          <h2>Who we are</h2>
          <p>
            Building Biblical Intellect (BBI) is a training and equipping
            platform that aims to build people with the accurate revelation and
            understanding of God’s word through the scriptures.
            <br />
            <br />
            As an organisation, we recognize and acknowledge the importance and
            necessity of the hope, encouragement, and wisdom derived from the
            Bible, and the impact of these in the lives of individuals and
            believers alike.  <br />
            <br />
            Over time, however, the overemphasis of these elements of the faith
            has limited the profundity of Scripture in the lives of many and
            prevented us from conceptualising God beyond a philanthropic scope.
            To put it simply, Christianity goes beyond taking from God.
            <br />
            <br />
            BBI exists to reveal the wisdom and intent of God by addressing the
            deeper complexities of scripture, bringing into focus the
            historical, cultural, and etymological contexts of the Biblical
            ages, while providing answers to pressing questions of our
            generation from a purely scriptural perspective.   <br />
            <br />
            Similarly, the BBI platform will bring simplicity and clarity to
            God's word by decrypting its seemingly paradoxical elements in order
            to build the faith of believers at any level of their journey.
            <br />
            <br />
            We believe that when believers come into epignosis, they grow in
            grace and peace, improve their walk with God and are ultimately
            empowered to achieve His purpose for their lives.  <br />
            <br />
            By engaging with our work, you will come to understand the richness
            and detail of the Bible on a more comprehensive level and improve
            (or begin) your relationship with Jesus.
          </p>
        </div>
        <div className="sect3">
          <div className="vision">
            <h4>Our vision</h4>
            <p>
              To raise a generation of believers, completely sound in Word and
              doctrine, furnished for every good work.
            </p>
          </div>
          <div className="mission">
            <h4>Our mission</h4>
            <p>
              To train and equip people in the Word of God, guiding them into
              accurate knowledge and revelation of our Lord Jesus and His
              kingdom, that they may grow in grace, experience peace and total
              wellbeing (shalom), deepen their walk with God, and rightly
              understand His ways, enabling them to fulfill His divine purpose
              for their lives.
            </p>
          </div>
        </div>
        <div className="sect4">
          <h2>Meet Pastor Eldridge Asamoah</h2>
          <img
            src="https://d14n4fsapeewqj.cloudfront.net/about/meetpastor.webp"
            alt=""
          />
          <p>
            Eldridge Asamoah is a pastor and entrepreneur who has ardently
            served within the pastoral ministry for over a decade. He is the
            founder of Building Biblical Intellect (BBI), and the Resident
            Pastor of the Universal Radiant Family branch in the United Kingdom
            and Europe.   <br />
            <br />
            He serves under the able leadership of Apostle Sefam L. Tamakloe,
            the Presiding Minister of the Universal Radiant Family Global.  {" "}
            <br />
            <br />
            After completing his undergraduate studies at the University of
            Ghana-Legon, Pastor Eldridge relocated to the United Kingdom to
            pursue his master’s degrees. He currently holds an MSc in Accounting
            and Finance from the University of Greenwich London, and an MSc
            International Business from Aston University.   <br />
            <br />
            Pastor Eldridge Asamoah is a man endowed by God with a dynamic
            teaching grace and an ardour for the propagation of the Gospel of
            Jesus Christ through the teaching of the unadulterated word of God.
              <br />
            <br />
            Pastor Eldridge's ministry has gained a massive following in the UK
            and across the globe, characterized by remarkable miracles, healing,
            signs, and wonders. His teaching ministry is particularly
            distinguished by profound revelations from God's word and has been
            the catalyst for innumerable life transformations.   <br />
            <br />
            The primary goal of his teaching ministry is to painstakingly convey
            the message of Christ, to avoid any misrepresentation about the
            character, person and intent of God. Pastor Eldridge firmly believes
            that the intentions of God are not meant to be hidden, however, it
            is the Holy Spirit that plays a crucial role in revealing Christ
            through scripture. With a unique prophetic gift, Pastor Eldridge has
            also delivered numerous prophecies that have been fulfilled over
            time, as testified by individuals who have experienced tangible
            manifestations.   <br />
            <br />
            Pastor Eldridge is one of two children born to Rev. Derek Asamoah
            and Mrs. Edith Barbara Annan-Asamoah.   <br />
            <br />
            Throughout his ministry, he has consistently demonstrated a
            lifestyle that points people to Jesus Christ, and his influence has
            led to significant growth in the lives of believers and their
            ministries.
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
